var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "19px",
    viewBox: "0 0 13 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "address") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mock-Ups",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback",
    transform: "translate(-1000.000000, -978.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 928.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(1000.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "address",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0 C2.9159,0 0,2.99650781 0,6.6796875 C0,7.92411328 0.335436111,9.13855469 0.970269444,10.1921641 L6.13000556,18.7368574 C6.22884167,18.9005469 6.40296944,19 6.59024167,19 C6.59168611,19 6.59309444,19 6.59453889,19 C6.78343611,18.9984785 6.957925,18.8959453 7.05495556,18.7293984 L12.083175,10.1019141 C12.6829806,9.07057031 13,7.88718945 13,6.6796875 C13,2.99650781 10.0841,0 6.5,0 Z M11.1534944,9.53035547 L6.58204444,17.3740898 L1.89103056,9.60561328 C1.36261667,8.72864453 1.07611111,7.71689453 1.07611111,6.6796875 C1.07611111,3.61037109 3.51325,1.10585937 6.5,1.10585937 C9.48675,1.10585937 11.9202778,3.61037109 11.9202778,6.6796875 C11.9202778,7.68613086 11.6526583,8.67201562 11.1534944,9.53035547 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,3 C4.5701,3 3,4.5701 3,6.5 C3,8.41757222 4.54455,10 6.5,10 C8.47956111,10 10,8.39649444 10,6.5 C10,4.5701 8.4299,3 6.5,3 Z M6.5,8.84111111 C5.20667222,8.84111111 4.15888889,7.78982778 4.15888889,6.5 C4.15888889,5.2134 5.2134,4.15888889 6.5,4.15888889 C7.7866,4.15888889 8.83722222,5.2134 8.83722222,6.5 C8.83722222,7.77100556 7.81382222,8.84111111 6.5,8.84111111 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.b533998df8a29d9e6bdc383d2e351548.svg";
export { ForwardRef as ReactComponent };